<div class="initialize-blocks-wrapper">
    <div id="left-panel" class="left"></div>
    <div id="right-panel" class="right"></div>
</div>

<div *ngIf="initializationText" class="initialization-text">
    {{initializationText}}
</div>

<div *ngIf="showBrandAnimation" class="brand-animation-wrapper">
    <app-brand-loading-animation (handleAnimationComplete)="onBrandAnimationComplete()"></app-brand-loading-animation>
</div>